
import { mapGetters, mapMutations } from 'vuex';
import Arrow45 from '~/components/svg/Arrow45';
import VueTypes from 'vue-types';
import MyPreloader from '~/components/ui/MyPreloader';
import EcomMenuBadges from '~/components/badges/EcomMenuBadges.vue';

export default {
    data() {
        return {
            activeMenuItem: null,
            isLoad: true,
            isSafari: false
        };
    },
    props: {
        isItemLink: VueTypes.bool.def(true),
        isHoverUsed: VueTypes.bool.def(true)
    },
    watch: {
        '$i18n.locale': '$fetch'
    },
    components: { EcomMenuBadges, Arrow45, MyPreloader },
    computed: {
        ...mapGetters(['getMenu']),
        ...mapGetters({
            globalSettings: 'global/globalSettings'
        })
    },
    methods: {
        ...mapMutations(['setMainMenu']),
        setActiveMenuItem(id) {
            this.activeMenuItem = id;
        },
        checkSafari() {
            const userAgent = navigator.userAgent;
            const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) && !/CriOS/i.test(userAgent);
            this.isSafari = isSafari;
        }
    },
    mounted() {
        this.checkSafari();
    },
    async fetch() {
        let menu = await this.$axios.$get('general/menu_tree');
        if (menu.length) {
            this.setMainMenu(menu);
            this.setActiveMenuItem(menu[0].id);
        }
        this.isLoad = false;
    },
    fetchOnServer: true,
    fetchKey: 'site-menu'
};
